var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg01"},[_c('Head',{attrs:{"title":"油烟健康码"}}),_c('el-row',{staticClass:"mod09",attrs:{"type":"flex","justify":"center"}},[_c('el-col',{staticClass:"box",attrs:{"span":12}},[_c('vue-qr',{attrs:{"text":_vm.downloadData.url,"margin":0,"size":200}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }